/* tslint:disable */
/* eslint-disable */
/**
 * Contract
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreationRequest } from '../model';
// @ts-ignore
import type { ErrorResponse } from '../model';
// @ts-ignore
import type { Response } from '../model';
/**
 * ServiceApplicationControllerApi - axios parameter creator
 * @export
 */
export const ServiceApplicationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 화면에서 약관에 동의하고 누른 신청을 접수함. **기관과 누른 계정은 토큰에서 유도하므로 본문으로 지정할 수 없음** — 그래서 남의 기관 것을 대신 접수하는 것이 불가능하며, 와이브레인 직원 토큰으로 부르면 그 직원의 소속 기관 신청이 됨. 서버 열쇠로는 부를 수 없음(403) — 그 인증의 주체는 사용자가 아니라 구독자라 기관을 알 수 없기 때문임. 이미 같은 계약에 같은 판의 기록이 있으면 409 이며, 이는 오류가 아니라 「이미 접수 완료」를 뜻함.
         * @summary 서비스 이용 신청 접수 — 사용자 토큰 전용
         * @param {CreationRequest} creationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply: async (creationRequest: CreationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'creationRequest' is not null or undefined
            assertParamExists('apply', 'creationRequest', creationRequest)
            const localVarPath = `/api/v2/service-applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(creationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceApplicationControllerApi - functional programming interface
 * @export
 */
export const ServiceApplicationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceApplicationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 화면에서 약관에 동의하고 누른 신청을 접수함. **기관과 누른 계정은 토큰에서 유도하므로 본문으로 지정할 수 없음** — 그래서 남의 기관 것을 대신 접수하는 것이 불가능하며, 와이브레인 직원 토큰으로 부르면 그 직원의 소속 기관 신청이 됨. 서버 열쇠로는 부를 수 없음(403) — 그 인증의 주체는 사용자가 아니라 구독자라 기관을 알 수 없기 때문임. 이미 같은 계약에 같은 판의 기록이 있으면 409 이며, 이는 오류가 아니라 「이미 접수 완료」를 뜻함.
         * @summary 서비스 이용 신청 접수 — 사용자 토큰 전용
         * @param {CreationRequest} creationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apply(creationRequest: CreationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apply(creationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceApplicationControllerApi.apply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceApplicationControllerApi - factory interface
 * @export
 */
export const ServiceApplicationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceApplicationControllerApiFp(configuration)
    return {
        /**
         * 화면에서 약관에 동의하고 누른 신청을 접수함. **기관과 누른 계정은 토큰에서 유도하므로 본문으로 지정할 수 없음** — 그래서 남의 기관 것을 대신 접수하는 것이 불가능하며, 와이브레인 직원 토큰으로 부르면 그 직원의 소속 기관 신청이 됨. 서버 열쇠로는 부를 수 없음(403) — 그 인증의 주체는 사용자가 아니라 구독자라 기관을 알 수 없기 때문임. 이미 같은 계약에 같은 판의 기록이 있으면 409 이며, 이는 오류가 아니라 「이미 접수 완료」를 뜻함.
         * @summary 서비스 이용 신청 접수 — 사용자 토큰 전용
         * @param {CreationRequest} creationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apply(creationRequest: CreationRequest, options?: any): AxiosPromise<Response> {
            return localVarFp.apply(creationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceApplicationControllerApi - object-oriented interface
 * @export
 * @class ServiceApplicationControllerApi
 * @extends {BaseAPI}
 */
export class ServiceApplicationControllerApi extends BaseAPI {
    /**
     * 화면에서 약관에 동의하고 누른 신청을 접수함. **기관과 누른 계정은 토큰에서 유도하므로 본문으로 지정할 수 없음** — 그래서 남의 기관 것을 대신 접수하는 것이 불가능하며, 와이브레인 직원 토큰으로 부르면 그 직원의 소속 기관 신청이 됨. 서버 열쇠로는 부를 수 없음(403) — 그 인증의 주체는 사용자가 아니라 구독자라 기관을 알 수 없기 때문임. 이미 같은 계약에 같은 판의 기록이 있으면 409 이며, 이는 오류가 아니라 「이미 접수 완료」를 뜻함.
     * @summary 서비스 이용 신청 접수 — 사용자 토큰 전용
     * @param {CreationRequest} creationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApplicationControllerApi
     */
    public apply(creationRequest: CreationRequest, options?: RawAxiosRequestConfig) {
        return ServiceApplicationControllerApiFp(this.configuration).apply(creationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

